export const productsList = [
  {
    productCode: 'dx_analytics_support',
    product: 'Analytics',
    productId: 503467,
    productName: 'Analytics ',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-analytics-3",
  },
  {
    productCode: 'mkto_support',
    product: 'Marketo Engage',
    productId: 503491,
    productName: 'Marketo Engage',
    link: '',
    type: 'product',
    isAccountVisible: true,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-marketo-engage-26",
  },
  {
    productCode: 'dx_target_support',
    product: 'Target',
    productId: 503476,
    productName: 'Target ',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-target-14",
  },
  {
    productCode: 'dx_campaign_support',
    product: 'Campaign Standard',
    productId: 503475,
    productName: 'Campaign',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-campaign-4",
  },
  {
    productCode: 'dx_audience_manager_support',
    product: 'Audience Manager',
    productId: 503486,
    productName: 'Audience Manager ',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-audience-manager-16",
  },
  {
    productCode: 'dx_campaign_onprem',
    product: 'Campaign Classic',
    productId: null,
    productName: '',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-campaign-4",
  },
  {
    productCode: 'dx_aem_assets_support',
    product: 'AEM as Cloud Service - Assets',
    productId: 503489,
    productName: 'Assets ',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-experience-manager-7",
  },
  {
    productCode: 'dx_aem_onprem',
    product: 'AEM On-Premise',
    productId: null,
    productName: '',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-experience-manager-7",
  },
  {
    productCode: 'dx_scene_7_support',
    product: 'AEM Dynamic Media/Scene7',
    productId: 503470,
    productName: '',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-experience-manager-7",
  },
  {
    productCode: 'dx_brand_portal_support',
    product: 'AEM Brand Portal',
    productId: 503470,
    productName: '',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-experience-manager-7",
  },
  {
    productCode: 'commerce_support',
    product: 'Commerce Manager',
    productId: 503491,
    productName: 'Commerce',
    link: '',
    type: 'product',
    isAccountVisible: true,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/?lang=en",
  },
  {
    productCode: 'dx_customer_journey_analytics_support',
    product: 'Customer Journey Analytics',
    productId: 503485,
    productName: 'Customer Journey Analytics',
    link: '',
    type: 'product',
    isAccountVisible: true,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-analytics-3",
  },
  {
    productCode: 'dx_audience_manager_support',
    product: 'Adobe Audience Manager',
    productId: 503510,
    productName: 'Audience Manager',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503458,
    link: "https://experienceleaguecommunities.adobe.com/adobe-audience-manager-16",
  },
  {
    productCode: 'dx_campaign_support',
    product: 'Adobe Campaign',
    productId: 503475,
    productName: 'Campaign Standard',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-campaign-4",
  },
  {
    productCode: 'dx_campaign_classic_support',
    product: 'Adobe Campaign Classic',
    productId: 503475,
    productName: 'Campaign Classic',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-campaign-4",
  },
  {
    productCode: 'dx_aem_sites_support',
    product: 'Adobe Experience Manager as a Cloud Service',
    productId: 503489,
    productName: 'Adobe Experience Manager as a Cloud Service',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-experience-manager-7",
  },
  {
    productCode: 'dx_aem_perf_support',
    product: 'Adobe Sites Optimizer',
    productId: 582032,
    productName: 'Adobe Sites Optimizer',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-journey-optimizer-15",
  },
  {
    productCode: 'dx_aep_support',
    product: 'Platform Core Services',
    productId: 503481,
    productName: 'Platform Core Services',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503460,
    link: "https://experienceleaguecommunities.adobe.com/adobe-experience-platform-18",
  },
  {
    productCode: 'dx_genstudio_support',
    product: 'GenStudio for Performance Marketing',
    productId: 554521,
    productName: 'GenStudio for Performance Marketing',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/?lang=en",
  },
  {
    productCode: 'dx_aem_ams_support',
    product: 'Adobe Experience Manager',
    productId: 503470,
    productName: 'Adobe Experience Manager',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-experience-manager-7",
  },
  {
    productCode: 'dx_aem_ams_support',
    product: 'Adobe Experience Manager as a Cloud Service',
    productId: 503489,
    productName: 'Adobe Experience Manager as a Cloud Service',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-experience-manager-7",
  },
  {
    productCode: 'dx_acwp_support',
    product: 'Adobe Campaign',
    productId: 503475,
    productName: 'Adobe Campaign',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-campaign-4",
  },
  {
    productCode: 'dx_aem_fcs_support',
    product: 'Adobe Experience Manager as a Cloud Service',
    productId: 503489,
    productName: 'Adobe Experience Manager as a Cloud Service',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-experience-manager-7",
  },
  {
    productCode: 'dx_aod_support',
    product: 'Adobe Experience Manager Document Services',
    productId: 503489,
    productName: 'Adobe Experience Manager Document Services',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-experience-manager-7",
  },
  {
    productCode: 'dx_campaign_mgd_support',
    product: 'Adobe Campaign',
    productId: 503475,
    productName: 'Adobe Campaign',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-campaign-4",
  },
  {
    productCode: 'dx_campaign_v_6_support',
    product: 'Adobe Campaign',
    productId: 503475,
    productName: 'Adobe Campaign',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-campaign-4",
  },
  {
    productCode: 'dx_offers_support',
    product: 'Adobe Journey Optimizer',
    productId: 503488,
    productName: 'Adobe Journey Optimizer',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-journey-optimizer-15",
  },
  {
    productCode: 'dx_rt_cdp_support',
    product: 'Real Time CDP',
    productId: 533248,
    productName: 'Real Time CDP',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    other: '',
    link: "https://experienceleaguecommunities.adobe.com/adobe-real-time-customer-data-platform-25",
  },
  {
    productCode: 'amm_support',
    product: 'Adobe Marketo Engage',
    productId: 503491,
    productName: 'Adobe Marketo Engage',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    other: '',
    link: "https://experienceleaguecommunities.adobe.com/adobe-marketo-engage-26",
  },
  {
    productCode: 'dx_cjm_support',
    product: 'Journey Optimizer',
    productId: 503488,
    productName: 'Adobe Journey Optimizer',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-journey-optimizer-15",
  },
  {
    productCode: 'dx_journeys_support',
    product: 'Adobe Journey Optimizer',
    productId: 503488,
    productName: 'Adobe Journey Optimizer',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-journey-optimizer-15",
  },
  {
    productCode: 'dx_commercecloud_support',
    product: 'Commerce Cloud',
    productId: 503473,
    productName: 'Adobe Commerce',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/?lang=en",
  },
  {
    productCode: 'dx_commercepaymentservices_support',
    product: 'Commerce Payment Services',
    productId: 503473,
    productName: 'Adobe Commerce',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/?lang=en",
  },
  {
    productCode: 'dx_a_commerce_cloudsrvc_support',
    product: 'Adobe Commerce as a Cloud Service',
    productId: 503473,
    productName: 'Adobe Commerce',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/?lang=en",
  },
  {
    productCode: 'dx_a_commerce_aco_support',
    product: 'Adobe Commerce Optimizer',
    productId: 503473,
    productName: 'Adobe Commerce',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/?lang=en",
  },
  {
    productCode: 'dx_a_commerce_cloudsrvc_ms_support',
    product: 'Adobe Commerce as a Cloud Service',
    productId: 503473,
    productName: 'Adobe Commerce',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/?lang=en",
  },
  {
    productCode: 'dx_genstudio_foundation_support',
    product: 'GenStudio for Performance Marketing',
    productId: 554521,
    productName: 'GenStudio for Performance Marketing',
    link: '',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/?lang=en",
  },
  {
    productCode: 'dx_workfront_fusion_support',
    enterpriseName: 'Workfront Fusion',
    productId: 503490,
    productName: 'Workfront',
    isAccountVisible: false,
    cloudId: 503461,
    type: 'product',
    link: "https://experienceleaguecommunities.adobe.com/adobe-workfront-22",
  },
  {
    productCode: 'dx_workfront_support',
    enterpriseName: 'Workfront',
    productId: 503490,
    productName: 'Workfront',
    type: 'product',
    isAccountVisible: false,
    cloudId: 503461,
    link: "https://experienceleaguecommunities.adobe.com/adobe-workfront-22",
  },
  {
    productCode: 'ADLM',
    enterpriseName: 'Adobe Learning Manager',
    productId: 503520,
    productName: 'Adobe Learning Manager',
    isAccountVisible: false,
    type: 'product',
    cloudId: 503458,
    link: "https://experienceleaguecommunities.adobe.com/?lang=en",
  },
  {
    productCode: 'CAPP',
    enterpriseName: 'Adobe Learning Manager',
    productId: 503520,
    productName: 'Adobe Learning Manager',
    isAccountVisible: false,
    cloudId: 503458,
    type: 'product',
    link: "https://experienceleaguecommunities.adobe.com/?lang=en",
  },
  {
    productCode: 'dx_advertising_search_support',
    enterpriseName: 'Adobe Advertising',
    productId: 503468,
    productName: 'Adobe Advertising',
    isAccountVisible: false,
    cloudId: 503461,
    type: 'product',
    link: "https://experienceleaguecommunities.adobe.com/adobe-advertising-2",
  },
  {
    productCode: 'dx_advertising_dsp_support',
    enterpriseName: 'Adobe Advertising',
    productId: 503468,
    productName: 'Adobe Advertising',
    isAccountVisible: false,
    cloudId: 503461,
    type: 'product',
    link: "https://experienceleaguecommunities.adobe.com/adobe-advertising-2",
  },
  {
    productCode: 'dx_ajo_btob_support',
    enterpriseName: 'Adobe Journey Optimizer B2B',
    productId: 552633,
    productName: 'Adobe Journey Optimizer B2B',
    isAccountVisible: false,
    cloudId: 503461,
    type: 'product',
    link: "https://experienceleaguecommunities.adobe.com/?lang=en",
  }
];
